import { Button } from "@mui/material";
import React from "react";

function TableButton({ children, color, onClick, fontWeight, hover, onMouseEnter, onMouseLeave }) {
  return (
    <Button
      onClick={onClick}
      sx={{
        backgroundColor: "transparent",
        color: color,
        fontWeight:fontWeight ? fontWeight : "bold",
        textTransform: "none",
        fontSize: "16px",
        padding: "0",
        minWidth: "auto",
        textDecoration:  hover ? "underline" : 'none',
        "&:hover": {
          backgroundColor: "transparent",
          textDecoration: 'underline'
        },
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Button>
  );
}

export default TableButton;
